<script>
import Vue from 'vue';
import ElemDebugOptions from './ElemDebug.vue';
import ElemBaseOptions from './ElemBase.vue';

export default Vue.config.silent === false ? ElemDebugOptions : ElemBaseOptions;
</script>
